import { render, staticRenderFns } from "./LvTemplateIndex.vue?vue&type=template&id=68d53f22"
import script from "./LvTemplateIndex.vue?vue&type=script&lang=js"
export * from "./LvTemplateIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports